
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
//import { FinancialNetCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import plantree from '../../assets/data/plan-tree.json';
import { FinancialItemIdService } from './../services/financial-item-id.service';
import { FinancialSummaryModeService } from './../services/financial-summary-mode.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-financial-summaries-properties',
  templateUrl: './financial-summaries-properties.component.html',
  styleUrls: ['./financial-summaries-properties.component.scss']
})
export class FinancialSummariesPropertiesComponent implements OnInit {

  public subscription: Subscription;
  //subscription2: Subscription;
  public filter: string = "";
  public title = "";
  public total = 0;
  public assetTotal = 0;
  public debtTotal = 0;
  public incomeTotal = 0;
  public expenseTotal = 0;
  public myUser;
  public myItemsList: {};
  public items: {}[] = [];
  public multiplier = 1;
  public templateName = "bank-account";
  public idToShow;
  public show = false;
  public canEdit = false;
  public _myCategoriesBalance: {}[];

  // @Input() myCategoriesBalance: {}[];
  @Input() set myCategoriesBalance(value: {}[]) {
    this._myCategoriesBalance = value;
    //
  }
  collapseStatus = [];

  //@Input() templateName;
  constructor(private userInfo: UserInfoService,
    private financialSectionFilterService: FinancialSectionsSetFilterService,
    private financialItemIdService: FinancialItemIdService,
    private zenplanData: ZpDataService,
    private financialSummaryModeService: FinancialSummaryModeService,
    public themeService: ThemeService) { }

  ngOnInit() {
    this.subscription = this.userInfo.getMessage().subscribe(async user => {
      this.myUser = await JSON.parse(user);
      this.filterList("property");
    });
    // this.subscription2 = this.financialItemsSetFilterService.getMessage().subscribe(async filter => {
    //   if (filter != "null") {
    //     this.filter = filter;
    //     this.filterList(filter);
    //   }
    // });

  }

  async filterList(filter) {
    this.filter = filter;
    if (filter) {
      let basename = "";
      plantree.forEach(function (category) {
        let mySection = category.sectionObjects.filter(section => section.section == filter);
        if (mySection.length > 0) {
          basename = mySection[0].baseName;
        }
      });
      this.templateName = basename + "-view";
      this.myItemsList = await this.zenplanData.getPlanSectionInfo(this.myUser, filter);
      this.title = this.myItemsList["sectionName"];
      // if (("my debts_my daily life").includes(this.myItemsList["category"]["planCategory"])) {
      //   this.multiplier = -1;
      // }
      // else {
      //   this.multiplier = 1;
      // }
      let mySection = this._myCategoriesBalance["sections"].find(section => section["sectionName"] == filter);
      // this.total = this.myItemsList["grandTotal"] * this.multiplier;
      // this.assetTotal = this.myItemsList["assetTotal"];
      // this.debtTotal = this.myItemsList["debtTotal"];
      // this.incomeTotal = this.myItemsList["incomeTotal"];
      // this.expenseTotal = this.myItemsList["expenseTotal"];
      //using the myCategoriesBalance which have the jointownership caculations
      this.assetTotal = mySection["assetTotal"];
      this.debtTotal = mySection["debtTotal"];
      this.incomeTotal = mySection["incomeTotal"];
      this.expenseTotal = mySection["expenseTotal"];
      if (mySection["categoryName"] == "my daily life") {
        this.total = this.incomeTotal + this.expenseTotal; //it will be either a income or an expense
      }
      else {
        this.total = /*this.assetTotal - this.debtTotal +*/ this.incomeTotal - this.expenseTotal;
      }
      this.items = this.myItemsList["items"];
      let counter = 0;
      this.items.forEach(item => {
        this.collapseStatus[counter] = false;
        counter++;
        item["itemTotal"] = item["itemTotal"] * this.multiplier;
      });
    }
    //     let mySectionObject = plantree.find(kk => kk.sectionObjects["section"] == filter);
    // let kkk = 0;
  }

  async view(itemId) {
    //this.idToShow = itemId;
    //await this.financialSectionFilterService.changeMessage("property");
    await this.financialItemIdService.changeMessage(itemId);
    await this.financialSummaryModeService.changeMessage("false");
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    //this.subscription2.unsubscribe();
  }

}
